// https://www.npmjs.com/package/linkifyjs
// https://www.npmjs.com/package/react-linkify
import React from 'react'
import Linkify from 'react-linkify'

export default ({ children }) => <Linkify>{children}</Linkify>
